import type { Maybe } from '@amazon/vinyl-util'
import { featureEnabled } from '@/core/featureGate'
import { getDeviceConfig, isTv } from '@/device/deviceConfig'
import { usesLwaAuth } from '@/auth/authRef'

/**
 * Whether this session offers merch: only the web player does, so TVs, the installed
 * apps and LWA sessions, whose token ElectricFeel checkout rejects, are off whatever the
 * `merch` gate says; on the web player the gate can still turn it off.
 */
export async function merchEnabled(): Promise<boolean> {
    return (
        !isTv() && !getDeviceConfig().installed && !usesLwaAuth() && (await featureEnabled('merch'))
    )
}

/** True for a path into the merch storefront (`/merch`, `/merch/shop?tag=`, `/merch/items/:id`). */
export function isMerchPath(path: Maybe<string>): boolean {
    return path === '/merch' || !!path?.match(/^\/merch[/?]/)
}

/** A server-driven row of merch: a merch shoveler or a merch-category grid. */
export function isMerchRow(itemType: Maybe<string>, template: Maybe<string>): boolean {
    return itemType === 'MERCH' || !!template?.startsWith('MERCH')
}

/** A category tile or pill Firefly types as merch, the Find merch-shop pill, or one that opens the storefront. */
export function isMerchCategory(category: {
    readonly id: string
    readonly href: string | null
    readonly merch?: true
}): boolean {
    return (
        category.merch === true ||
        category.id.includes('CATEGORY_MERCH_SHOP') ||
        isMerchPath(category.href)
    )
}
